import { useGymEmailConfigForm } from "../../../hooks/admin/gym/useGymEmailConfigForm";
import { GymEmailConfigFields } from "./emailConfigFields";
import { LoadingSpinner } from "../../common/loadingSpinner";
import { FormCard } from "../../common/ui/formCard";

export const GymEmailConfig = () => {
  const {
    emailConfig,
    isLoading,
    isSaving,
    adminReport,
    setAdminReport,
    salesReport,
    setSalesReport,
    reminders,
    setReminders,
    lowStockAlerts,
    setLowStockAlerts,
    paymentFailedEnabled,
    setPaymentFailedEnabled,
    inactivity,
    setInactivity,
    addRecipient,
    removeRecipient,
    addExcludeKey,
    removeExcludeKey,
    handleSubmit,
  } = useGymEmailConfigForm();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };

  if (isLoading) {
    return (
      <LoadingSpinner
        message="Cargando configuración de correo"
        size="sm"
        className="py-8"
      />
    );
  }

  if (!emailConfig) {
    return null;
  }

  return (
    <FormCard
      showCardWrapper={false}
      header={{
        title: "Configuración de correo electrónico",
        subtitle:
          "Gestiona los destinatarios y configuraciones de reportes por correo",
      }}
      onSubmit={onSubmit}
      isLoading={isSaving}
      submitButtonText="Guardar configuración de correo"
      submitButtonLoadingText="Guardando configuración de correo..."
      gap="md"
    >
      <GymEmailConfigFields
        adminReport={adminReport}
        setAdminReport={setAdminReport}
        salesReport={salesReport}
        setSalesReport={setSalesReport}
        reminders={reminders}
        setReminders={setReminders}
        lowStockAlerts={lowStockAlerts}
        setLowStockAlerts={setLowStockAlerts}
        paymentFailedEnabled={paymentFailedEnabled}
        setPaymentFailedEnabled={setPaymentFailedEnabled}
        inactivity={inactivity}
        setInactivity={setInactivity}
        addRecipient={addRecipient}
        removeRecipient={removeRecipient}
        addExcludeKey={addExcludeKey}
        removeExcludeKey={removeExcludeKey}
      />
    </FormCard>
  );
};
